import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RegisterService } from '../../services/register.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-missing-data-register',
  templateUrl: './missing-data-register.component.html',
  styleUrls: ['./missing-data-register.component.scss']
})
export class MissingDataRegisterComponent  {


  taxRegimens: SelectItem[] = [
    { key: 'PFA', value: 'Si' },
    { key: 'PFAE', value: 'No' },
  ]

  form!: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<MissingDataRegisterComponent>,
    private registerService: RegisterService,
    private fb: FormBuilder
  ) {
    this.initForm();
  }

  initForm() {
    this.form = this.fb.group({
      phoneNumber: ['', [Validators.required, Validators.pattern(`^[0-9]{10}$`)]],
      rfc: ['', [Validators.required, Validators.pattern(/^[a-zA-Z]{3,4}(\d{6})((\D|\d){2,3})?$/)]],
      persontype: ['', [Validators.required]],
      flowType: environment.templateSuffix === '' ? ['A'] : ['B']
    });
  }
 
  setInputValidation(field: string, isActive: boolean) {

    const control = this.form.get(field);

    control!.setValidators(isActive ? [Validators.required] : []);
    control!.setValue(isActive ? control!.value : '');
    control!.updateValueAndValidity();
  }

  send() {

    this.form.markAllAsTouched();

    if (this.form.valid) {

      const body = this.form.value;

      this.registerService.updateUserAttributes(body, this.data.idUser).subscribe({
        next: () => this.dialogRef.close(body),
        error: (error) => console.error(error)
      });

    }

  }

  isInvalid(campo: string) {
    return this.form.get(campo)!.errors && this.form.get(campo)!.touched;
  }

  hasErrors(campo: string) {
    return this.isInvalid(campo) ? 'error-border' : ''
  }

}

interface SelectItem {
  key: string;
  value: string;
}
